import * as React from 'react';

export function Skeleton({
  className = '',
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`shadcn-skeleton ${className}`.trim()} style={style} {...props} />;
}
